import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                  韩漫网
                </span>
              </div>
              <p className="text-sm text-background-50/70 leading-relaxed">
                韩漫网是专业的韩国漫画在线阅读平台，为您提供最新、最热、最好看的免费韩国漫画资源。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/70 hover:text-primary-300 transition-colors whitespace-nowrap"
                    >
                      {cat.name}漫画
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-50/70 hover:text-primary-300 transition-colors whitespace-nowrap">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-50/70 hover:text-primary-300 transition-colors whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-50/70 hover:text-primary-300 transition-colors whitespace-nowrap">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-50/70 hover:text-primary-300 transition-colors whitespace-nowrap">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-background-50/70">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-sm"></i>
                  </div>
                  <span>contact@hanmanwang.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/70">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-sm"></i>
                  </div>
                  <span>400-888-6666</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-50/70">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  <span>北京市朝阳区建国路88号</span>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-sm text-background-50"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-sm text-background-50"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line text-sm text-background-50"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/50">
              &copy; 2026 韩漫网 HanManWang.com 版权所有 | ICP备2024000000号
            </p>
            <p className="text-xs text-background-50/50">
              本站所有漫画均来自互联网，版权归原作者所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}